import { memo } from 'react';
import { Handle, Position, type NodeProps, type Node } from '@xyflow/react';
import { Box, Text } from '@chakra-ui/react';
import { useColorModeValue } from '@components/ui/color-mode';
import type { TerminalNodeData } from '../types';

type TerminalNodeType = Node<TerminalNodeData, 'terminal'>;

const TerminalNode = ({ data, selected }: NodeProps<TerminalNodeType>) => {
  const isBlocked = String(data.label).toLowerCase().includes('bloqueado');

  const blockedBg = useColorModeValue('red.50', 'red.950');
  const blockedBorder = useColorModeValue('red.400', 'red.600');
  const blockedText = useColorModeValue('red.700', 'red.300');
  const baseBg = useColorModeValue('green.50', 'green.950');
  const baseBorder = useColorModeValue('green.500', 'green.600');
  const baseText = useColorModeValue('green.700', 'green.300');

  return (
    <Box
      bg={isBlocked ? blockedBg : baseBg}
      border="2px solid"
      borderColor={selected ? 'argos.fg' : isBlocked ? blockedBorder : baseBorder}
      borderRadius="full"
      px={5}
      py={2}
      minW={140}
      textAlign="center"
      boxShadow="sm"
      cursor="default"
    >
      <Handle type="target" position={Position.Left} />
      <Text fontSize="sm" fontWeight={600} color={isBlocked ? blockedText : baseText}>
        {data.label}
      </Text>
    </Box>
  );
};

export default memo(TerminalNode);
